// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderHeader_container__2OLJ5","highlight":"OrderHeader_highlight__2W7c3"};